import { isStringEmpty } from './is-string-empty.util';

export const isValidPhone = (str: string) => {
  if (isStringEmpty(str)) {
    return false;
  }
  return /^\+?\d+$/.test(str);
};
